import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from '@angular/core';
import {NotificationRuleSetting} from "../../api/model/notificationRuleSetting";
import {OrgUnitModel} from "../../api/model/orgUnitModel";
import {Facility} from "../../core/facilities/facilities.service";

interface MedAlertAndCategory {
    category: string;
    alerts: NotificationRuleSetting[];
}

@Component({
    selector: 'my-notifications-table',
    styleUrls: ['notifications-table.component.scss'],
    templateUrl: 'notifications-table.component.html'
})
export class NotificationsTableComponent implements OnChanges {

    @Input() 
    set notifications(value: NotificationRuleSetting[]) {
        if (value) {
            this.allNotifications = value;
            this.isLoading = false;
        }
        else {
            this.allNotifications = [];
            this.isLoading = true;
        }
    }

    @Input() nurseRole: boolean;

    @Input() allFacilities: Facility[];

    /** Event back to the caller when the checkbox changes */
    @Output() smsChanged = new EventEmitter<boolean>();

    alertsByCategory: MedAlertAndCategory[] = [];
     /** Is the data loading? Show the progress indicator. */
     isLoading: boolean = false;

     allNotifications: NotificationRuleSetting[];

    ngOnChanges(changes: {[propName: string]: SimpleChange}) {
        let notificationsChanged = changes['notifications'];
        if(notificationsChanged){
            this.allNotifications = notificationsChanged.currentValue ? notificationsChanged.currentValue : [];
            console.log(this.allNotifications)
            this.alertsByCategory = this.splitNotificationsByCategory();
        }
    }

    splitNotificationsByCategory(): MedAlertAndCategory[] {
        let result = [];
        let actionableText = 'Financial Alerts';

        result.push({category: actionableText, alerts: this.actionableNotifications});

        let informationalText = 'Clinical Alerts';
        let informationalAlerts = this.informationalNotifications;

        result.push({category: informationalText, alerts: informationalAlerts});

        let PharmacyCommunicationText = 'Pharmacy Communications'
        let PharmacyCommunicationAlerts = this.PharmacyCommunicationNotifications;

        result.push({category: PharmacyCommunicationText,alerts: this.PharmacyCommunicationNotifications})
        return result;
    }

    get actionableNotifications(): NotificationRuleSetting[] {
        if(this.allNotifications)
            return this.allNotifications.filter(f => f.IsFinancialAlert)
        return [];
    }

    private get informationalNotifications(): NotificationRuleSetting[] {
        if(this.allNotifications)
            return this.allNotifications.filter(f => !f.IsFinancialAlert && !f.IsPharmacyCommunications)//need another flag for Pharm Comm
        return [];
    }

    private get PharmacyCommunicationNotifications(): NotificationRuleSetting[]{
        if(this.allNotifications)
            return this.allNotifications.filter(f => f.IsPharmacyCommunications) //need another flag for Pharm Comm
        return [];
    }

    getSupportedFacilitiesCount(notification: NotificationRuleSetting): number {
        // Its valid for all facilities, so just return a positive number as long as a facility is selected.
        if(notification.HasNoRuleValue && this.allFacilities.filter(f=>f.selected).length>0) {
            return 1;
        }

        let notificationFacilities: OrgUnitModel[] = notification.Facilities;

        return this.findSupportedFacilities(notificationFacilities).length;
    }

    hasUnsupportedFacilities(notification: NotificationRuleSetting): boolean {
        if(notification.HasNoRuleValue){
            return false;
        }

        let notificationFacilities: OrgUnitModel[] = notification.Facilities;

        let supported = this.findSupportedFacilities(notificationFacilities);
        let selected = this.allFacilities.filter(f=>f.selected);

        if(selected.length === 0){
            // If there are no selected facilities do not show the warning
            return false;
        }

        let result = false;
        selected.forEach(facility =>
        {
            let found = supported.find(f=> f.Id==facility.id)
            if(found == null){
                result = true;
            }
        });

        return result;
    }

    getTooltipText(notification: NotificationRuleSetting): string {
        let list = notification.Facilities;

        let result = "";
        list.forEach(f=>
        {

            let currentFacility = this.allFacilities.find(facility => f.Id === facility.id);
            if(currentFacility && currentFacility.selected){
                result += f.Name;

                if(list.indexOf(f) != list.length-1){
                    result += ', ';
                }
            }
        });

        return result;
    }

    private findSupportedFacilities(facilities: OrgUnitModel[]): OrgUnitModel[] {
        let selectedFacilities = this.allFacilities.filter(f=> f.selected);

        let result: OrgUnitModel[] =[];

        facilities.forEach(facility => {
            if(selectedFacilities.find(f=> facility.Id==f.id)){
                result.push(facility);
            }
        })
        return result;
    }

    checkPhoneNumber(e) {
        if (e && e.target) {
            this.smsChanged.emit(e.target.checked);
        }
    }
}
